import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    handleQueryError,
} from "../../../helpers/utils/RtkQueryUtils";
import {serialize} from "../../../helpers/utils/Utils";

export const highRiskAccountApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchHighRiskAccounts: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/high-risk-account/search?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['highRiskAccount'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        verifyHighRiskAccountById: build.mutation({
            query: ({highRiskAccountId,requestBody}) => {
                return {
                    url: `/ajax/high-risk-account/verify/${highRiskAccountId}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['highRiskAccount'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
    }),
});


export const {
    useSearchHighRiskAccountsQuery,
    useVerifyHighRiskAccountByIdMutation
} = highRiskAccountApi;